import {gsap} from "gsap";

let transition = {
    name: 'opacity-transition',
    leave(data) {
        return gsap.to(data.current.container, {
            autoAlpha: 0,
            duration:  0.2
        });
    },

    enter(data) {
        data.next.container.style.opacity = '0';
        return gsap.to(data.next.container, {
            opacity: 1,
            duration: 0.5
        });
    }
}

export default transition;
